import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { DEFAULT_DATA_LABEL_OPTIONS } from '@/components/widget/visualizations/internal/BarChart/utils';
import { deleteUndefinedValues } from '@/utils/objects';
import { encodeSelections } from '@/utils/widget/parseSelections';
import { useBarStyles } from '@/components/widget/visualizations/internal/BarChart/stylesTheme';
import BorderFields, { BorderStyle } from '@/components/Editor/Form/fields/common/Border';
import RevealPill, { PillSwitch } from '@/components/Editor/Form/fields/RevealPill';
import { AxesGridLinesRevealPill, AxisRevealPill } from '@/components/Editor/Form/fields/ChartJsAxes';
import BorderRadius from '@/components/Editor/Form/fields/BorderRadius';
import ColumnDesign from '@/components/Editor/Form/barChart/fields/ColumnDesign';
import ColorPalletMenu from '@/components/Editor/Form/fields/ColorPalletMenu';
import Legend from '@/components/Editor/Form/fields/Legend';
import Headings from '@/components/Editor/Form/fields/Headings';
import ChartLabels from '@/components/Editor/Form/fields/ChartLabels';
import ChartType from '@/components/Editor/Form/fields/ChartType';
import TrendlineFields from '@/components/Editor/Form/fields/Trendline';
import DataLabels from '@/components/Editor/Form/fields/DataLabels';
import Animation from '@/components/Editor/Form/fields/Animation';
import Collapsible from '@/components/Editor/Form/fields/common/Collapsible';
import { CHART_TYPES } from './settings';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const WidgetEditFormBarChartOptions = _ref => {
  var _config$globalSeriesO, _globalSeriesOptions$, _globalSeriesOptions$2, _globalSeriesOptions$3, _globalSeriesOptions$4, _globalSeriesOptions$5, _globalSeriesOptions$6, _config$globalSeriesO2, _config$globalSeriesO3, _config$trendline, _config$trendline2, _config$trendline3, _config$trendline4, _config$trendline5, _config$trendline6;

  let {
    widgetId,
    sectionId,
    config,
    hasLegend: defaultHasLegend,
    hasTrendline = true,
    exampleValue,
    legendsCount,
    isGrouped,
    dataBoundaries,
    pillVariant,
    children,
    onChange,
    onEditSelections
  } = _ref;
  const nameSpace = `bar-chart-${widgetId}-${sectionId}`;
  const {
    barThemeStyles,
    defaultStyles,
    themeCtx: {
      colorPallet: defaultColorPallet
    }
  } = useBarStyles(config);
  const {
    labelsSelections,
    chartType = 'vertical',
    globalSeriesOptions,
    colorPallet = defaultColorPallet
  } = config;
  const isBorderColumnsModified = barThemeStyles.barBorderWidth !== defaultStyles.barBorderWidth || Boolean(barThemeStyles.barBorderColor);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ColorPalletMenu, {
      label: "Colors",
      colors: colorPallet,
      palletColorOverrides: config.palletColorOverrides,
      openButtonVariant: pillVariant,
      onOverridePalletColors: (name, colors) => onChange('palletColorOverrides', {
        [name]: colors
      }),
      onChange: colorPallet => onChange('', {
        colorPallet
      })
    }), onEditSelections ? /*#__PURE__*/_jsx(ChartLabels, {
      nameSpace: nameSpace,
      selections: labelsSelections ? encodeSelections(labelsSelections || []) : undefined,
      defaultSelections: config.defaultLabelsSelections,
      openButtonVariant: pillVariant,
      onChange: onChange,
      onEditSelections: () => onEditSelections('labels')
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(ChartType, {
      chartType: config.chartType,
      defaultChartType: "vertical",
      options: CHART_TYPES,
      openButtonVariant: pillVariant,
      onChange: chartType => onChange('', {
        chartType
      })
    }), /*#__PURE__*/_jsx(BorderRadius, {
      nameSpace: nameSpace,
      label: "Column Radius",
      openButtonVariant: pillVariant,
      radius: {
        topLeft: config.barRadiusTopLeft,
        topRight: config.barRadiusTopRight,
        bottomLeft: config.barRadiusBottomLeft,
        bottomRight: config.barRadiusBottomRight
      },
      defaults: {
        topLeft: defaultStyles.barRadiusTopLeft,
        topRight: defaultStyles.barRadiusTopRight,
        bottomLeft: defaultStyles.barRadiusBottomLeft,
        bottomRight: defaultStyles.barRadiusBottomRight
      },
      onChange: updates => onChange('', deleteUndefinedValues({
        barRadiusTopLeft: updates.topLeft,
        barRadiusTopRight: updates.topRight,
        barRadiusBottomLeft: updates.bottomLeft,
        barRadiusBottomRight: updates.bottomRight
      }))
    }), /*#__PURE__*/_jsx(ColumnDesign, {
      nameSpace: nameSpace,
      barPercentage: config.barPercentage,
      categoryPercentage: config.categoryPercentage,
      openButtonVariant: pillVariant,
      defaults: {
        barPercentage: defaultStyles.barPercentage,
        categoryPercentage: defaultStyles.categoryPercentage
      },
      onChange: updates => onChange('', updates)
    }), /*#__PURE__*/_jsx(RevealPill, {
      label: "Column Borders",
      openButtonVariant: pillVariant,
      disableOpen: barThemeStyles.barBorderWidth === 0,
      activeState: /*#__PURE__*/_jsx(PillSwitch, {
        checked: barThemeStyles.barBorderWidth !== defaultStyles.barBorderWidth,
        onChange: checked => {
          onChange('globalSeriesOptions', {
            barBorderWidth: checked ? 1 : null,
            barBorderColor: null
          });
        }
      }),
      variant: isBorderColumnsModified ? 'active' : '',
      children: /*#__PURE__*/_jsx(BorderFields, {
        pill: false,
        nameSpace: nameSpace,
        width: ((_config$globalSeriesO = config.globalSeriesOptions) === null || _config$globalSeriesO === void 0 ? void 0 : _config$globalSeriesO.barBorderWidth) ?? undefined,
        color: (barThemeStyles === null || barThemeStyles === void 0 ? void 0 : barThemeStyles.barBorderColor) ?? '',
        enabledButtonStyles: [BorderStyle.Solid, BorderStyle.Dashed],
        textOverrides: {
          clearBorder: 'Reset to default',
          widthPlaceholder: `${defaultStyles.barBorderWidth ?? 0}`
        },
        onChangeColor: borderColor => onChange('globalSeriesOptions', {
          barBorderColor: borderColor
        }),
        onChangeWidth: borderWidth => {
          const update = borderWidth !== null ? borderWidth : null;
          onChange('globalSeriesOptions', {
            barBorderWidth: update
          });
        },
        onDelete: () => onChange('globalSeriesOptions', {
          barBorderColor: null,
          barBorderWidth: null
        })
      }, nameSpace)
    }), /*#__PURE__*/_jsx(Headings, {
      nameSpace: nameSpace,
      widgetId: widgetId,
      sectionId: sectionId,
      hasHeading: config.hasHeading,
      title: config.title,
      openButtonVariant: pillVariant,
      onChange: updates => onChange('', updates)
    }), /*#__PURE__*/_jsx(Legend, _objectSpread({
      nameSpace: nameSpace,
      caption: `Add a legend showing each ${isGrouped ? 'group' : 'value'}`,
      legendPosition: config.legendPosition,
      legends: config.legends,
      legendsCount: legendsCount,
      hasLegend: config.hasLegend ?? defaultHasLegend,
      hasLegendInputs: true,
      openButtonVariant: pillVariant,
      onChange: updates => onChange('', updates)
    }, onEditSelections && {
      onEditSelections: () => onEditSelections('legends')
    })), /*#__PURE__*/_jsx(DataLabels, {
      nameSpace: nameSpace,
      exampleValue: exampleValue,
      display: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : (_globalSeriesOptions$ = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$ === void 0 ? void 0 : _globalSeriesOptions$.display,
      anchoring: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : (_globalSeriesOptions$2 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$2 === void 0 ? void 0 : _globalSeriesOptions$2.anchoring,
      alignment: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : (_globalSeriesOptions$3 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$3 === void 0 ? void 0 : _globalSeriesOptions$3.alignment,
      rotation: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : (_globalSeriesOptions$4 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$4 === void 0 ? void 0 : _globalSeriesOptions$4.rotation,
      template: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : (_globalSeriesOptions$5 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$5 === void 0 ? void 0 : _globalSeriesOptions$5.template,
      color: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : (_globalSeriesOptions$6 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$6 === void 0 ? void 0 : _globalSeriesOptions$6.color,
      defaults: {
        color: defaultStyles === null || defaultStyles === void 0 ? void 0 : defaultStyles.chartDataLabelColor,
        alignment: DEFAULT_DATA_LABEL_OPTIONS.align
      },
      openButtonVariant: pillVariant,
      onChange: update => onChange('globalSeriesOptions', {
        dataLabels: _objectSpread(_objectSpread({}, globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : globalSeriesOptions.dataLabels), update)
      })
    }), /*#__PURE__*/_jsx(AxisRevealPill, {
      nameSpace: `${nameSpace}-x-axes`,
      label: "X Axis",
      axisDisplay: config.xAxisDisplay,
      axisTitle: config.xAxisTitle,
      axisTemplate: config.xAxisTemplate,
      defaultTemplate: (_config$globalSeriesO2 = config.globalSeriesOptions) === null || _config$globalSeriesO2 === void 0 ? void 0 : _config$globalSeriesO2.xAxisTemplate,
      exampleValue: exampleValue,
      openButtonVariant: pillVariant // xAxis scale
      ,
      hasScalesMinMax: chartType === 'horizontal',
      scaleMin: config.xScaleMin,
      scaleMax: config.xScaleMax,
      scaleDataMin: dataBoundaries === null || dataBoundaries === void 0 ? void 0 : dataBoundaries.min,
      scaleDataMax: dataBoundaries === null || dataBoundaries === void 0 ? void 0 : dataBoundaries.max,
      onChange: updates => onChange('', deleteUndefinedValues({
        xAxisDisplay: updates.axisDisplay,
        xAxisTitle: updates.axisTitle,
        xAxisTemplate: updates.axisTemplate,
        xScaleMin: updates.scaleMin,
        xScaleMax: updates.scaleMax
      }))
    }), /*#__PURE__*/_jsx(AxisRevealPill, {
      nameSpace: `${nameSpace}-y-axes`,
      label: "Y Axis",
      axisDisplay: config.yAxisDisplay,
      axisTitle: config.yAxisTitle,
      axisTemplate: config.yAxisTemplate,
      defaultTemplate: (_config$globalSeriesO3 = config.globalSeriesOptions) === null || _config$globalSeriesO3 === void 0 ? void 0 : _config$globalSeriesO3.yAxisTemplate,
      exampleValue: exampleValue,
      openButtonVariant: pillVariant,
      hasScalesMinMax: chartType === 'vertical',
      scaleMin: config.yScaleMin,
      scaleMax: config.yScaleMax,
      scaleDataMin: dataBoundaries === null || dataBoundaries === void 0 ? void 0 : dataBoundaries.min,
      scaleDataMax: dataBoundaries === null || dataBoundaries === void 0 ? void 0 : dataBoundaries.max,
      onChange: updates => onChange('', deleteUndefinedValues({
        yAxisDisplay: updates.axisDisplay,
        yAxisTitle: updates.axisTitle,
        yAxisTemplate: updates.axisTemplate,
        yScaleMin: updates.scaleMin,
        yScaleMax: updates.scaleMax
      }))
    }), /*#__PURE__*/_jsx(AxesGridLinesRevealPill, {
      nameSpace: nameSpace,
      colorPallet: colorPallet,
      openButtonVariant: pillVariant,
      axesGrid: {
        // xAxis
        xAxisGridVisible: config.xAxisGridVisible,
        xAxisGridColor: config.xAxisGridColor,
        xAxisGridBorderWidth: config.xAxisGridBorderWidth,
        xAxisGridBorderDash: config.xAxisGridBorderDash,
        // yAxis
        yAxisGridVisible: config.yAxisGridVisible,
        yAxisGridColor: config.yAxisGridColor,
        yAxisGridBorderWidth: config.yAxisGridBorderWidth,
        yAxisGridBorderDash: config.yAxisGridBorderDash
      },
      defaults: {
        xAxisGridVisible: defaultStyles.xAxisGridVisible,
        xAxisGridBorderWidth: defaultStyles.xAxisGridBorderWidth,
        xAxisGridColor: defaultStyles.xAxisGridColor,
        xAxisGridBorderDash: defaultStyles.xAxisGridBorderDash,
        yAxisGridVisible: defaultStyles.yAxisGridVisible,
        yAxisGridBorderWidth: defaultStyles.yAxisGridBorderWidth,
        yAxisGridColor: defaultStyles.yAxisGridColor,
        yAxisGridBorderDash: defaultStyles.yAxisGridBorderDash
      },
      onChange: updates => onChange('', updates)
    }), hasTrendline ? /*#__PURE__*/_jsx(TrendlineFields, {
      description: "Regression line corresponding to all data points.",
      isCreated: Boolean(config.trendline),
      nameSpace: `${widgetId}-${sectionId}`,
      display: (config === null || config === void 0 ? void 0 : (_config$trendline = config.trendline) === null || _config$trendline === void 0 ? void 0 : _config$trendline.display) || false,
      borderWidth: config === null || config === void 0 ? void 0 : (_config$trendline2 = config.trendline) === null || _config$trendline2 === void 0 ? void 0 : _config$trendline2.borderWidth,
      borderDash: config === null || config === void 0 ? void 0 : (_config$trendline3 = config.trendline) === null || _config$trendline3 === void 0 ? void 0 : _config$trendline3.borderDash,
      borderColor: config === null || config === void 0 ? void 0 : (_config$trendline4 = config.trendline) === null || _config$trendline4 === void 0 ? void 0 : _config$trendline4.borderColor,
      backgroundColor: config === null || config === void 0 ? void 0 : (_config$trendline5 = config.trendline) === null || _config$trendline5 === void 0 ? void 0 : _config$trendline5.backgroundColor,
      tension: config === null || config === void 0 ? void 0 : (_config$trendline6 = config.trendline) === null || _config$trendline6 === void 0 ? void 0 : _config$trendline6.tension,
      hasLegend: Boolean(config.hasLegend),
      openButtonVariant: pillVariant,
      onChange: update => onChange('trendline', update),
      onDelete: () => onChange('', {
        trendline: null
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {}), children, /*#__PURE__*/_jsx(Animation, {
      nameSpace: nameSpace,
      animation: config.animation,
      openButtonVariant: pillVariant,
      onChange: update => onChange('animation', update)
    }), /*#__PURE__*/_jsx(Collapsible, {
      nameSpace: nameSpace,
      collapsible: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : globalSeriesOptions.collapsible,
      openButtonVariant: pillVariant,
      onChange: update => onChange('globalSeriesOptions', update)
    })]
  });
};

export default WidgetEditFormBarChartOptions;